var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[(!_vm.mobile)?_c('router-view',{staticClass:"left",attrs:{"name":"left"}}):_vm._e(),_c('router-view',{staticClass:"right",attrs:{"name":"right"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }